export const SERVICE_CODE = 'EXPENSE_TYPE' + '_SERVICE';
